import { render, staticRenderFns } from "./pamerdatavisual.vue?vue&type=template&id=658edb54"
import script from "./pamerdatavisual.vue?vue&type=script&lang=js"
export * from "./pamerdatavisual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports